<div style="text-align: center;" class="animated fadeIn col col-ms-12 ">
    <br>
    <h3>ANPY OCR - MM-CG-2020</h3>
  <hr>
  <!--
  <div>
    <input id="botonsubirarchivo" type="file" accept="image/*" class="form-control browse" ngModel (change)="getFiles($event)">
    <br>
  </div>
  <div style="text-align: center;" *ngIf="fotob64">
    <img id="imasubida" style="height: 200px; width: 400px;" src="{{fotob64}}">
    <span> Texto: "{{Result}}"</span>
  </div>-->
  <h5 *ngIf="ocrResult == 'recognizing text'">{{ ocrResult }}.. <span id="progress"></span></h5>
  <p *ngIf="getQr != 'noget';" >QR: {{ getQr }}</p>
  <h5 *ngIf="fechaok">&nbsp;&nbsp;&nbsp;Fecha: &nbsp;&nbsp;<input style="width: 160px;" [(ngModel)]="fechaok" name="fechaok" type="text"></h5>
  <h5 *ngIf="importeok"> Importe: $&nbsp;<input style="width: 160px;" [(ngModel)]="importeok" name="importeok" type="number"></h5>
  <h5 *ngIf="totalok">&nbsp;&nbsp;&nbsp;&nbsp;Total:&nbsp;&nbsp; $<input style="width: 160px;" [(ngModel)]="totalok" name="totalok" type="text"></h5>
  <!--
  <h5 *ngIf="totalok" > Total: {{ totalok | currency:"$" }}</h5>
  -->
  <div *ngIf="ocrResult != 'recognizing text' && ocrResult != 'Pulse SCAN para reconocer..'" class="text-center">
    <a href="" class="btn btn-default btn-rounded" data-toggle="modal" data-target="#frameModalBottom">Ver texto <i class="far fa-eye ml-1 text-white"></i></a>
  </div>

  <div class="spinner-grow text-primary" role="status">
    <span class="sr-only">Loading...</span>
  </div>
  <hr>
  <button id="botonScan" *ngIf="fotodetalle" (click)="reconocer()" type="button" class="btn btn-secondary " data-dismiss="modal">SCAN! <i *ngIf="loading" class="fas fa-cog fa-spin"></i></button>
<hr>

  <div *ngIf="fotodetalle" style="height: 250px; width: 300px; text-align: center;" class="container">
    <img id="ima" *ngIf="fotodetalle" src="{{fotodetalle}}" />
    <p class="title">IMAGEN A SUBIR</p>
    <div style="height: 250px; width: 300px; text-align: center;" class="overlay"></div>
    <div class="button"><a style="cursor: pointer" (click)="quitarImagen()"> Quitar Imagen </a></div>
  </div>
  <br>
  <div style="text-align: center;">
    <button (click)="borraDatos()" style="height: 60px;" *ngIf="!fotodetalle" type="button" class="btn btn-secondary dropdown-toggle" data-toggle="modal" data-target="#modalImagen">
        SUBIR IMAGEN!
    </button>
    <button hidden (click)="getPos()" >GetPosi</button>
    <button hidden (click)="getDatos()" >obtenerFecha</button>
    <button hidden (click)="borraBasura()" >borra basura</button>
  </div>
  <hr>
  <div>
      <p> GETDEV = {{ camara }} / {{ camarasdispo }}
        <select class="form-control">
            <option *ngFor="let camms of objdevices">{{camms.label}}</option>
        </select>
      </p>
      <p *ngIf="errorqr">ERROR: {{errorqr}}</p>
  </div>

</div>

<!-- Modal IMAGEN elije captura o subir -->
<div class="modal fade" id="modalImagen" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
      <div id="modalito" class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">ELIJA OPCIÓN</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
          </div>
          <div class="modal-body">
              
                <div id="tieneimagen">
                  <span id="botonsubes" class="efectoFoto">
                      <input id="botonsube" style="height: 179px; width: 226px" data-dismiss="modal" type="image" name="foto" ng2FileSelect [uploader]="uploader" class="btn btn-primary" data-toggle="modal" data-target="#modalsubir" src="../../../assets/img/camara.png" >
                  </span>
                  <span id="botoncaptura" (click)="prendeCamara()" data-dismiss="modal" type="button" class="efectoFoto btn btn-primary" data-toggle="modal" data-target="#modalcaptura">
                      <img style="height: 165px; width: 200px" src="../../../assets/img/camaraa.png" >
                  </span>
                  <span id="botoncaptura" (click)="getQR()" data-dismiss="modal" type="button" class="efectoFoto btn btn-primary" data-toggle="modal" data-target="#modalqr">
                    <img style="height: 165px; width: 200px" src="../../../assets/img/qr2.png" >
                  </span>
                  <span id="botoncaptura" data-dismiss="modal" type="button" class="efectoFoto btn btn-primary" data-toggle="modal" data-target="#modalbarcode">
                    <img style="height: 165px; width: 200px" src="../../../assets/img/barco4.png" >
                  </span>
              </div>
          </div>
          <div class="modal-footer" style="text-align: center; display: block;">
              <button (click)="apagaCamara()" type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
          </div>
      </div>
  </div>
</div>

<!-- Modal captura webcam (pc) -->
<div style="overflow-y: scroll;" class="modal fade" id="modalcaptura" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
      <div id="modalcap" class="modal-content">
          <div hidden class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">CAPTURE CON SU WEBCAM</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body" style="text-align: center">
              <div>
                  <div>
                      <webcam id="webcamm" [height]="400" [width]="400" [trigger]="triggerObservable" (imageCapture)="handleImage($event)" *ngIf="showWebcam" [allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable" [videoOptions]="videoOptions" (cameraSwitched)="cameraWasSwitched($event)"
                          (initError)="handleInitError($event)">
                      </webcam>
                  </div>
                  <button style="height:100px; width: 405px; margin-left: 30px;" class="actionBtn btn btn-info btn-block" type="button" id="snap" (click)="triggerSnapshot(); snackCamara();" data-dismiss="modal">***CAPTURAR***</button>
              </div>
              <!-- lo quito temporalmente (muestra la foto que saque)
              <div class="snapshot animated fadeIn" *ngIf="webcamImage">
                  <h6>Imagen capturada</h6>
                  <img class="animated fadeIn" id="imacapturada" [src]="webcamImage.imageAsDataUrl" />
              </div>

              <h4 *ngIf="errors.length > 0">Messages:</h4>
              <ul *ngFor="let error of errors">
                  <li>{{error | json}}</li>
              </ul>
          -->
              <!--
                  <video #video id="video" width="320" height="240" autoplay style="display:none"></video>
                  
                  <webcam width="320" height="240"></webcam>
              </div>
              <div style="text-align: center;">
                  <button style="height: 60px;" class="btn btn-secondary" type="button" id="snap" (click)="capture()">¡CAPTURAR!</button>
              </div>
              <hr>
              <div style="text-align: center">
                  <canvas #canvas id="canvas" width="640" height="480"></canvas>
                  <ul>
                      <div style="text-align: center">
                          <li *ngFor="let c of captures">
                              <img id="ulcaptura" src="{{ c }}" height="100px" />
                          </li>
                      </div>

                  </ul>
              </div>
          -->
          </div>
          <!--
          <div class="modal-footer" style="text-align: center;">
              <span>
                  <button (click)="limpiacam()" type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                  <button (click)="snackCamara()" type="button" class="btn btn-primary" data-dismiss="modal" [disabled]="!fotodetalle">Guardar Captura </button>
              </span>
          </div>
      -->
      </div>
  </div>
</div>

<!-- Modal Subir imagen desde pc-->
<div class="modal fade" id="modalsubir" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
      <div id="modalito" class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Acción</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
          </div>
          <div class="modal-body">
              <div>
                  <input id="botonsubirarchivo" type="file" accept="image/*" class="form-control browse" ngModel (change)="getFiles($event)">
                  <br>
              </div>
              <div style="text-align: center; width:300; height:200px" *ngIf="fotob64">
                  <img id="imasubida" style="width:300px; height:200px" src="{{fotob64}}">
              </div>
          </div>

          <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
              <button (click)="snackCamara(); subirImagenDesdePc();" type="button" class="btn btn-primary" data-dismiss="modal" [disabled]="!fotob64">Subir Imagen </button>
          </div>
      </div>
  </div>
</div>

<!-- Central Modal Warning Demo-->
<div class="modal fade left" id="ModalWarning" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-notify modal-warning modal-side modal-bottom-left" role="document">
    <!--Content-->
    <div class="modal-content">
      <!--Header-->
      <div class="modal-header">
        <p class="heading">Data Recognizer</p>

        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" class="white-text">&times;</span>
        </button>
      </div>

      <!--Body-->
      <div class="modal-body">

        <div class="row">
          <div class="col-3 text-center">
            <img src="https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg" alt="IMG of Avatars"
              class="img-fluid z-depth-1-half rounded-circle">
            <div style="height: 10px"></div>
            <p class="title mb-0">Jane</p>
            <p class="text-muted " style="font-size: 13px">tes</p>
          </div>

          <div class="col-9">
            <p>{{ocrResult}}</p>
          </div>
        </div>


      </div>

      <!--Footer-->
      <div class="modal-footer justify-content-center">
        <!--<a type="button" class="btn btn-warning">Get it now <i class="far fa-gem ml-1 white-text"></i></a>-->
        <a type="button" class="btn btn-outline-warning waves-effect" data-dismiss="modal">No, thanks</a>
      </div>
    </div>
    <!--/.Content-->
  </div>
</div>

<!-- Frame Modal Bottom -->
<div style="top: 100px;" class="modal fade bottom" id="frameModalBottom" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  aria-hidden="true">
  <!-- Add class .modal-frame and then add class .modal-bottom (or other classes from list above) to set a position to the modal -->
  <div class="modal-dialog modal-frame modal-bottom" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="row d-flex justify-content-center align-items-center">
            <label for="exampleFormControlTextarea1">Texto Obtenido</label>
            <textarea class="form-control rounded-0" id="exampleFormControlTextarea1" rows="10">{{ ocrResult }}</textarea>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!--    MODAL QR     -->
<div style="overflow-y: scroll;" class="modal fade" id="modalqr" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div id="modalcap" class="modal-content">
            <div hidden class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">ENFOQUE QR</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" style="text-align: center">
                <qr-scanner [debug]="false" [canvasWidth]="1080" [canvasHeight]="720" [stopAfterScan]="true" [updateTime]="500">
                </qr-scanner>
                <a (click)="changeCam()" class="btn btn-danger btn-rounded">Girar Cam <i class="far fa-eye ml-1 text-white"></i></a>
                <button hidden id="cerrarModalQR" data-dismiss="modal">ss</button>
            </div>
        </div>
    </div>
</div>
